import { Controller } from "@hotwired/stimulus"

// Drives the customer missing-document-request page: picking which missing
// documents to ask for, choosing recipients, and gating the Send button (plus
// keeping the send confirmation's body in sync with the selections).
export default class extends Controller {
  static targets = ["documentCheckbox", "form", "previewButton", "recipientCheckbox", "sendButton"]

  connect() {
    this.refresh()
  }

  refresh = () => {
    const documentCount = this.checkedValues(this.documentCheckboxTargets).length
    const recipients = this.checkedValues(this.recipientCheckboxTargets)

    this.previewButtonTarget.disabled = documentCount === 0
    this.sendButtonTarget.disabled = documentCount === 0 || recipients.length === 0
    this.formTarget.dataset.body = this.confirmationBody(documentCount, recipients)
  }

  checkedValues(targets) {
    return targets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
  }

  confirmationBody(documentCount, recipients) {
    const documents = `${documentCount} document${documentCount === 1 ? "" : "s"}`
    return [
      `This will email a re-upload request for ${documents} to:`,
      recipients.join("\n"),
      "Emails cannot be unsent — please make sure the requested documents and recipients are correct before sending.",
    ].join("\n\n")
  }
}
